function initToggles() {
	
	const toggles = document.querySelectorAll('label.toggle');
	toggles.forEach((toggle) => {
		
		const checkbox = toggle.querySelector('input');
		const slider = toggle.querySelector('.slider');
		const dot = slider.querySelector('.dot');
		
		dot.style.setProperty('--label-off', '"'+toggle.dataset.labelOff+'"');
		dot.style.setProperty('--label-on', '"'+toggle.dataset.labelOn+'"');
		
		document.addEventListener('keydown', (e)=>{
			if(document.activeElement === slider) {
				if((e.key === 'Enter') ||  (e.key === ' ')) {
					e.preventDefault();
					checkbox.checked = !checkbox.checked;
				}
			}
		});
	});

}
initToggles();

  